<template>
    <div>
        <h1 class="display-heading">E-Wallet Application List</h1>

        <div class="table-responsive">
            <div ref="tableSection">
                <table ref="listTable" class="table table-hover">
                    <col width="50">
                    <col width="200">
                    <col>
                    <col>
                    <col width="100">
                    <col width="100">
                    <col width="150">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Submission Date</th>
                            <th scope="col">Clinic Name</th>
                            <th scope="col">Applicant Name</th>
                            <th scope="col">Status</th>
                            <th scope="col">Approval</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="applicationList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>
                        <tr v-for="(application, index) in applicationList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</th>
                            <td>{{application.addedAt}}</td>
                            <td>{{application.clinicName}}</td>
                            <td>{{application.applicantName}}</td>
                            <td>
                                <span class="badge text-nowrap" :class="{
                                    'badge-success': application.isProcessed,
                                    'badge-secondary': !application.isProcessed,
                                }">
                                    {{application.isProcessed ? 'Processed' : 'Not Processed Yet'}}
                                </span>
                            </td>
                            <td>
                                <template v-if="application.isProcessed && (application.isApproved || application.isDisapproved)">
                                    <span class="badge text-nowrap" :class="{
                                        'badge-success': application.isApproved,
                                        'badge-danger': application.isDisapproved,
                                    }">
                                        {{(application.isApproved && !application.isDisapproved) ? 'Approved' : 'Disapproved'}}
                                    </span>
                                </template>
                                <template v-else>
                                    Pending
                                </template>
                            </td>
                            <td>
                                <router-link :to="{
                                    'name': 'e-wallet-application-admin-view',
                                    'params': {
                                        'applicationId': application.applicationId
                                    }
                                }">
                                View
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
    </div>
</template>

<script>
import {
    convertToUserReadableDateTime
} from '@/utilities';
import pagination from '@/components/pagination';
export default {
    'components': {
        pagination
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getApplications();
            });
        }
    },
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'applicationList': []
        };
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getApplications();
    },
    'methods': {
        getApplications () {
            this.axios.post('EWalletApplication/List', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.applicationList = list.map((application) => ({
                    'isProcessed': application.ip,
                    'isApproved': application.ia,
                    'isDisapproved': application.id,
                    'applicantName': application.an,
                    'clinicName': application.cn,
                    'addedAt': application.aa ? convertToUserReadableDateTime(application.aa) : '-',
                    'updatedAt': application.ua ? convertToUserReadableDateTime(application.ua) : '-',
                    'applicationId': application.aid
                }));
            });
        }
    }
};

</script>

<style>

</style>
